export const joinWith = (strings: string[], joiner = ' '): string =>
  strings.filter(str => str && str.length > 0).join(joiner);

export const fullName = ({ firstName = '', lastName = '' }: { firstName?: string; lastName?: string }): string =>
  joinWith([firstName, lastName]);

export type cityRegionType = {
  city?: string;
  regionName?: string;
};

export const cityRegion = ({ city = '', regionName = '' }: cityRegionType): string =>
  joinWith([city, regionName], ', ');
